import Vue from 'vue'

import {
  Row,
  Col,
  Cell,
  CellGroup,
  Icon,
  Popup,
  Loading,
  Overlay,
  Toast,
  Field,
  Dialog,
  ActionSheet,
  NavBar,
  Tabbar,
  TabbarItem,
  Button,
  Image,
  List,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  Sticky,
  ImagePreview,
  PullRefresh
} from 'vant'

import Layout from '@/components/layout'

Toast.setDefaultOptions({ duration: 800 })

Vue.use(Row)
  .use(Col)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Popup)
  .use(Loading)
  .use(Overlay)
  .use(Toast)
  .use(Field)
  .use(NavBar)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Dialog)
  .use(ActionSheet)
  .use(Button)
  .use(Image)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(Swipe)
  .use(SwipeItem)
  .use(Sticky)
  .use(ImagePreview)
  .use(PullRefresh)

Vue.component('t-layout', Layout)
